import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './store/store'
import { ConfigProvider } from 'antd';
import ru_Ru from 'antd/lib/locale/ru_RU';
import locale from 'antd/locale/ru_RU';

import dayjs from 'dayjs';

import 'dayjs/locale/ru';

dayjs.locale('ru');

createRoot(document.getElementById('root')).render(
  <ConfigProvider locale={locale}
  theme={{
    token: {
      colorPrimary: '#b35fce',
      components: {
      },
    },
  }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
